if (!customElements.get("buy-buttons")) {
  customElements.define(
    "buy-buttons",
    class BuyButtons extends HTMLElement {
      constructor() {
        super();
        this.sticky_act = document.querySelector(".buy-buttons--sticky");
        if (this.sticky_act) {
          this.InitialiseIntersectionObserver();
        }
      }
      InitialiseIntersectionObserver() {
        const options = {
          root: null,
          rootMargin: "0px",
          threshold: 0,
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // Get the position of the element relative to the viewport
            const elementPosition = entry.boundingClientRect.top;
            // Add class only when element moves above the viewport
            if (!entry.isIntersecting && elementPosition < 0) {
              this.sticky_act.classList.add("in-view");
            } else {
              this.sticky_act.classList.remove("in-view");
            }
          });
        }, options);

        // Start observing the atc button
        observer.observe(this);
      }
    },
  );
}
